import { useForm, useWatch } from "react-hook-form";
import { formValues, schema } from "./validations";
import { FROM, TO } from "./consts";
import { getRequiredFields } from "@/lib/utils";
import { toast } from "@/components/Toast";
import { useCopyRuleMutation } from "@/services";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useRef } from "react";

const useCopyDistributionConfig = ({
  setOpen
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const communityData = useSelector((state: RootState) => state.currentData.communityData);
  const skipData = useRef<any>(null);

  const form = useForm<formValues>({
    defaultValues: {
      [FROM]: "",
      [TO]: ""
    }
  });
  
  const requiredFields = getRequiredFields(schema);
  const fromData = useWatch({ control: form.control });
  const { mutate: copyInfo, isPending: isCopyPending } =
    useCopyRuleMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong"
        );
        return error?.response?.data?.message;
      },
      onSuccess: ({data}: any) => {
        const copyData = data?.data;
        if (copyData?.copiedAllocationCount) {
          toast.success(`Rules Copied Successfully`);
          setOpen(false);
        } else {
          skipData.current = copyData;
        }
        
      },
    });

    const onConfirmCopy = (data: formValues) => {
      copyInfo({
        data: {
          communityId: communityData?.communityId,
          ...data 
        }
  
      })
    };

  return {
    form,
    requiredFields,
    isCopyPending,
    onConfirmCopy,
    skipData: skipData.current,
    fromData
  };
};

export default useCopyDistributionConfig;